'use client';

import { Container } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const PageContainer = styled(Container)`
    margin-bottom: ${getPurpurSpacing('1200')};
    ${purpurMedia('lg')`
        margin-bottom: ${getPurpurSpacing('1600')};
    `}
`;

export const PageHeadingWrapper = styled.div`
    margin-top: ${getPurpurSpacing('600')};
    margin-bottom: ${getPurpurSpacing('300')};

    display: flex;
    flex-wrap: nowrap;
    gap: ${getPurpurSpacing('200')};
    flex-direction: column;

    ${purpurMedia('md')`
        margin-top: ${getPurpurSpacing('600')};
        margin-bottom: ${getPurpurSpacing('400')};
                
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    `}

    ${purpurMedia('lg')`
        margin-top: ${getPurpurSpacing('1200')};
        margin-bottom: ${getPurpurSpacing('400')};
    `}
`;

export const CardsListWrapper = styled.div`
    margin-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('800')};

    ${purpurMedia('md')`
        margin-top: ${getPurpurSpacing('400')};
        margin-bottom: ${getPurpurSpacing('1200')};
    `}

    ${purpurMedia('lg')`
        margin-top: ${getPurpurSpacing('400')};
        margin-bottom: ${getPurpurSpacing('1200')};
    `}
`;
